import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { AlertService } from './alert.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';
import {HttpClient} from '@angular/common/http';


@Injectable()
export class HolidayCalendarService {

  constructor(
  	private http: HttpClient,
    private httpClient: HttpClient,
    private commonService: CommonService,
    private alertService: AlertService,
  ) { }

  saveHolidays(holidays:any): Promise<any>{
    return this.http.post(this.commonService.getPrefixUrlService() + 'Service.svc/saveHoliday',
      JSON.stringify(holidays), {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        if (response) {
        	console.log('response : ', response)
          //this.alertService.success(response['message']);
          } else {
          //this.alertService.error('error')
        }
        return response;
      });
  }

  getHolidaysByCompany(company): Promise<any> {
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getHolidaysByCompany/' + company;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }

  deleteHolidays(holidays:any): Promise<any>{
  	console.log('ingresando al servicio')
    return this.http.post(this.commonService.getPrefixUrlService() + 'Service.svc/deleteHoliday',
      JSON.stringify(holidays), {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        if (response) {
        	console.log('response : ', response)
          //this.alertService.success(response['message']);
          } else {
          //this.alertService.error('error')
        }
        return response;
      });
  }

}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/services/holiday-calendar.service.ts